angular.module('jv.applicantGrid.controller', ['ngRoute'])
    .controller('jvApplicantGridController', [
        '$scope', '$rootScope', 'videoService', '$q',
        function($scope, $rootScope, videoService, $q) {
            
            //TODO: PRANAV. Currently adding this, so that we can add a service for video modals.
            $scope.$on('VIDEO_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showVideoModalAdHoc', value);
            });

            $scope.$on('MOVE_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showMoveCandidateModal', value);
            });

            $scope.$on('SEND_NOTE_CLICKED', function(event, value) {
                $rootScope.$emit('showSendNoteModal', value);
            });

            $scope.$on('DELETE_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showDeleteCandidateModal', value);
            });

            $scope.$on('ADD_TO_REQ_MODAL_CLICKED', function(event, value) {
                $rootScope.$emit('showAddToReqModal', value);
            });

            $scope.$on('SEND_MSG_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showSendMessageModal', value);
            });
            $scope.$on('SUBMIT_HM_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showsubmitToHMModal', value);
            });

            $scope.$on('VIDEO_MODAL_CLICKED_WORKFLOW', function(event, value) {
                $rootScope.$broadcast('showVideoModalForWorkflow', value);
            });

            $scope.$on('ADD_TO_COLLECTION_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showAddToCollectionModal', value);
            });

            $scope.$on('CHANGE_STATUS_MODAL_CLICKED', function(event, value) {
                $rootScope.$broadcast('showChangeStatusModal', value);
            });

            $scope.$on('REJECT_CANDIDATES_MODAL_CLICKED', function(event, bulk, value) {
                $rootScope.$broadcast('showRejectCandidateModal', bulk, value);
            });
        }
    ]);
